'use strict';

angular.module('sellers')
.directive('resize', ['$rootScope', '$window', function ($rootScope, $window) {
  return function (scope, element) {
    var w = angular.element($window);

    scope.getWindowDimensions = function () {
      return { 'h': w.height(), 'w': w.width() };
    };

    scope.$watch(scope.getWindowDimensions, function (newValue, oldValue) {
      scope.windowHeight = newValue.h;
      scope.windowWidth = newValue.w;

      $rootScope.display = (scope.windowWidth <= 480)? 'small' : 'large';

      scope.columns = {height: (newValue.h-50)+'px'}

    }, true);
    
    w.bind('resize', function () {
      scope.$apply();
    });
  }
}]);